import CardComponent from '../../../Component/Level/Card';
import ITask from '../../../Utility/Task/ITask';
import LevelTaskHelper from '../../LevelTaskHelper';
import CardSystem, { getCardHandler } from '../CardSystem';
import CardStateAnimationHelper from './CardStateAnimationHelper';

export default class CardStateSyncTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        const state = system.state.getState();
        const previousState = system.state.getState().previousState;

        system.sortCardsInPlay(state.levelState.cardsState);

        if (state.levelState.tasks) {
            for (let taskData of state.levelState.tasks) {
                LevelTaskHelper.handleTask(system, taskData);
            }
        }

        const taskCards = [];

        if (state.levelState.cardsState.tasks) {
            for (let taskData of state.levelState.cardsState.tasks) {
                taskCards.push(...taskData.cards);
                CardStateAnimationHelper.handleTask(system, taskData);
            }
        }

        for (let cardID in state.levelState.cardsState.cards) {
            const card = system.getCardByID(cardID);
            if (taskCards.indexOf(cardID) !== -1) {
                // Sync to previous state.
                getCardHandler(card).handleStateChange(previousState, system);
            } else if (!card.getComponent(CardComponent).animating) {
                // Sync to next state.
                getCardHandler(card).handleStateChange(state, system);
            }
        }
    }
}
